var _circle, _path, _path2, _path3, _path4, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoulette(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "white",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0631 7.77382C19.9422 5.37014 17.9124 3.51017 15.4202 2.60308L12 12L21.0631 7.77382Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.93692 7.77382C4.05778 5.37014 6.08758 3.51017 8.5798 2.60308L12 12L2.93692 7.77382Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.93692 16.2262C4.05778 18.6299 6.08758 20.4898 8.5798 21.3969L12 12L2.93692 16.2262Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0631 16.2262C19.9422 18.6299 17.9124 20.4898 15.4202 21.3969L12 12L21.0631 16.2262Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0003,
    cy: 12,
    r: 7.27273,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoulette);
export default __webpack_public_path__ + "static/media/roulette.f613621386a0bf4a1de2325725b303c6.svg";
export { ForwardRef as ReactComponent };